<template>
  <el-popover
    placement="bottom-start"
    trigger="hover"
    content="查看积分规则"
  >
    <span
      class="icon-sapn"
      slot="reference"
      @click="goJfgz"
    ><i
        class="iconfont icon-wenhao"
        slot="reference"
      ></i></span>
  </el-popover>
</template>

<script>
export default {
  props:{
     isRule:{
       type: Boolean,
       default:false
     }
  },
  methods: {
    goJfgz () {
      this.$emit("openRule")
    }
  }
}
</script>

<style lang="less" scoped>
.icon-sapn {
  display: inline-block;
  margin-left: 13px;
  width: 30px;
  height: 28px;
  cursor: pointer;
  i {
    font-size: 20px;
  }
}
</style>
